<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.demandSide"
              placeholder="请输入需求方"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click="addFun()"
            >
              创建物料委托制作单
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @add="addFun"
          @del="delFun"
        />
      </div>

      <!-- 新增 -->
      <add-edit-dialog
        :event-type="'add'"
        :send-array="dataArray"
        :supplier="supplier"
        :dialog-title="dialogAddTitle"
        :dialog-visible.sync="dialogAddVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改
import addEditDialog from './addEditDialog'
import { loadMaterialsDemandListDataApi, removeMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsCommissionedOrderTodoList',
  components: { CustomTable, addEditDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    sourceType: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_commissioned_order_todo_add_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '创建物料委托制作单',
            method: 'add'
          },
          {
            prop: 'del',
            label: '作废物料需求申请',
            method: 'del'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            materialsName: '',
            demandSide: '',
            todoMake: 'true',
            confirmSupplier: 1 // 总部制作
          }
        }
      },
      isPaging: true,
      typeOptions: [{ value: 1, label: '方案内需求' }, { value: 2, label: '方案外需求' }],
      dialogAddTitle: '创建物料委托制作单',
      dialogAddVisible: false,
      multipleSelection: [],
      supplier: 0,
      dataArray: [] // 选中的物料需求数组
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'typeValue', label: '需求类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 110 },
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
          { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 100 },
          { prop: 'schemeContent', label: '需求来源', filterColumn: 'scheme_content', width: 200 },
          { prop: 'demandSide', label: '需求方', filterColumn: 'demand_side', width: 100 },
          { prop: 'materialsName', label: '物料名称', filterColumn: 'materials_name', width: 150 },
          { prop: 'auditMakeNumber', label: '制作数量', filterColumn: 'audit_make_number', width: 110 },
          { prop: 'receiveDepotName', label: '收货库房', filterColumn: 'receive_depot_name', width: 120 },
          { prop: 'receiver', label: '收货人', filterColumn: 'receiver', width: 100 },
          { prop: 'auditorName', filterColumn: 'auditor_name', label: '审核人', width: 105 },
          { prop: 'auditTimeValue', filterColumn: 'audit_time', label: '审核时间', width: 150, isBetween: true },
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      this.tableList.tableQuery.sort.order = ''
      loadMaterialsDemandListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建物料委托制作单
    addFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({ message: '请选择要制作的物料', type: 'warning' })
        return false
      } else {
        this.supplier = 1
        this.dataArray = this.multipleSelection
        this.dialogAddVisible = !this.dialogAddVisible
      }

    },
    // 作废
    delFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({ message: '请选择要作废的申请', type: 'warning' })
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message({ message: '只能选择一条要作废的申请', type: 'warning' })
        return false
      }
      let selectData = this.multipleSelection[0]
      if (selectData.type !== 2) {
        this.$message({ message: '方案内物料需求申请不能作废', type: 'warning' })
        return
      }
      this.$confirm('是否确定作废该物料需求申请？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        removeMaterialsDemandApi({ id: selectData.id, isOrderDel: '1' }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.reloadMasterData()
          }
        })
      }).catch(() => { })
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
